import { create } from 'zustand';

interface FilterState {
  year: number;
  locationId: string | null;

  setYear: (year: number) => void;
  setLocation: (locationId: string | null) => void;
}

export const useFilterStore = create<FilterState>()((set) => ({
  year: new Date().getFullYear(),
  locationId: null,

  setYear: (year) => set({ year }),
  setLocation: (locationId) => set({ locationId }),
}));
